import React from "react";
import PaymentDetailView from "./PaymentDetailView";

export interface PaymentDetailModalProps {
  open: boolean;
  paymentId: string | null;
  onClose: () => void;
}

/** List / embedded contexts: payment detail in a dialog. Routes use {@link PaymentDetailView} with `presentation="page"`. */
const PaymentDetailModal: React.FC<PaymentDetailModalProps> = ({
  open,
  paymentId,
  onClose
}) => (
  <PaymentDetailView
    presentation="modal"
    open={open}
    paymentId={paymentId}
    onClose={onClose}
  />
);

export default PaymentDetailModal;
